import { Actions, AdminGroupActions, AdminGroupSettingsNamespaceState } from './types';

export const defaultState: AdminGroupSettingsNamespaceState = {
  initialized: false,
  groups: [],
};

export default function adminGroupSettingsReducer(
  state: AdminGroupSettingsNamespaceState = defaultState,
  action: AdminGroupActions,
) {
  switch (action.type) {
    case Actions.Example: {
      return {
        ...state,
        groups: action.payload.groups,
      };
    }
    default:
  }
  return state;
}
